var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { TableBody, TableCell, TableRow, TextField } from '@mui/material';
import { debounce } from 'lodash';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'react-redux';
import { formatNumberByLocale } from '../../../../util/locale';
import { StableAutocomplete } from '../../../common/autocomplete/stable';
import { WizardTable } from '../../common/WizardTable';
import { waitForApiSliceTerminal } from '../../common/waitForApiSliceTerminal';
import { OrgConfigWizardContext } from '../../context';
import { useUpdateLocationAPI } from '../../selectors';
var toBaseline = function (f) {
  return {
    locationName: f.locationName,
    locationType: f.locationType
  };
};
var baselinesEqual = function (a, b) {
  return a.locationName === b.locationName && a.locationType === b.locationType;
};
export var ReviewLocationSection = function (_a) {
  var _b, _c, _d, _e;
  var location = _a.location,
    registry = _a.registry,
    onSaved = _a.onSaved;
  var t = useTranslation('orgConfig', {
    keyPrefix: 'orgConfigWizard.locationsStep'
  }).t;
  var tReview = useTranslation('orgConfig', {
    keyPrefix: 'orgConfigWizard.reviewStep'
  }).t;
  var store = useStore();
  var _f = useContext(OrgConfigWizardContext).isReadOnly,
    isReadOnly = _f === void 0 ? false : _f;
  var _g = useState({}),
    formMap = _g[0],
    setFormMap = _g[1];
  var formMapRef = useRef(formMap);
  useEffect(function () {
    formMapRef.current = formMap;
  }, [formMap]);
  var baselineRef = useRef({});
  var _h = useUpdateLocationAPI(location.id),
    updateLocation = _h[1];
  var form = (_b = formMap[location.id]) !== null && _b !== void 0 ? _b : null;
  // Populate form from API data (skip if dirty)
  useEffect(function () {
    setFormMap(function (prev) {
      var _a;
      var _b;
      if ((_b = prev[location.id]) === null || _b === void 0 ? void 0 : _b.isDirty) return prev;
      var mapped = {
        locationName: location.locationName,
        locationType: location.locationType,
        isDirty: false
      };
      baselineRef.current[location.id] = toBaseline(mapped);
      return __assign(__assign({}, prev), (_a = {}, _a[location.id] = mapped, _a));
    });
  }, [location]);
  var handleFormChange = useCallback(function (updater) {
    setFormMap(function (prev) {
      var _a;
      var _b;
      var current = (_b = prev[location.id]) !== null && _b !== void 0 ? _b : {
        locationName: location.locationName,
        locationType: location.locationType,
        isDirty: false
      };
      return __assign(__assign({}, prev), (_a = {}, _a[location.id] = updater(current), _a));
    });
  }, [location.id, location.locationName, location.locationType]);
  var locationRef = useRef(location);
  useEffect(function () {
    locationRef.current = location;
  }, [location]);
  var updateLocationRef = useRef(updateLocation);
  useEffect(function () {
    updateLocationRef.current = updateLocation;
  }, [updateLocation]);
  var doSave = useCallback(function (locId) {
    return __awaiter(void 0, void 0, void 0, function () {
      var f, baseline, loc, saveKey, ok;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            f = formMapRef.current[locId];
            if (!(f === null || f === void 0 ? void 0 : f.isDirty)) return [2 /*return*/, true];
            baseline = baselineRef.current[locId];
            if (baseline && baselinesEqual(toBaseline(f), baseline)) {
              setFormMap(function (prev) {
                var _a;
                return __assign(__assign({}, prev), (_a = {}, _a[locId] = __assign(__assign({}, f), {
                  isDirty: false
                }), _a));
              });
              return [2 /*return*/, true];
            }
            if (!f.locationName.trim()) return [2 /*return*/, false];
            loc = locationRef.current;
            saveKey = "orgConfigLocationUpdate-".concat(locId, ":PUT");
            return [4 /*yield*/, waitForApiSliceTerminal(store, saveKey, function () {
              return updateLocationRef.current({
                locationName: f.locationName,
                locationType: f.locationType,
                address: loc.address,
                totalSeats: loc.totalSeats,
                city: loc.city,
                region: loc.region,
                stateProvince: loc.stateProvince,
                countryName: loc.countryName,
                countryCode: loc.countryCode
              });
            })];
          case 1:
            ok = _a.sent();
            if (ok) {
              baselineRef.current[locId] = toBaseline(f);
              setFormMap(function (prev) {
                var _a;
                return __assign(__assign({}, prev), (_a = {}, _a[locId] = __assign(__assign({}, f), {
                  isDirty: false
                }), _a));
              });
              onSaved();
            }
            return [2 /*return*/, ok];
        }
      });
    });
  }, [store, onSaved]);
  var scheduleDebouncedSave = useMemo(function () {
    return debounce(function (locId) {
      void doSave(locId);
    }, 500);
  }, [doSave]);
  // Auto-save when dirty
  useEffect(function () {
    if (!(form === null || form === void 0 ? void 0 : form.isDirty)) return;
    scheduleDebouncedSave(location.id);
  }, [form === null || form === void 0 ? void 0 : form.isDirty, form === null || form === void 0 ? void 0 : form.locationName, form === null || form === void 0 ? void 0 : form.locationType, location.id, scheduleDebouncedSave]);
  // Register with registry
  useEffect(function () {
    registry.register('location', {
      flush: function () {
        return __awaiter(void 0, void 0, void 0, function () {
          return __generator(this, function (_a) {
            scheduleDebouncedSave.cancel();
            return [2 /*return*/, doSave(location.id)];
          });
        });
      },
      cancelPending: function () {
        return scheduleDebouncedSave.cancel();
      },
      get isDirty() {
        var _a, _b;
        return (_b = (_a = formMapRef.current[location.id]) === null || _a === void 0 ? void 0 : _a.isDirty) !== null && _b !== void 0 ? _b : false;
      }
    });
    return function () {
      return registry.unregister('location');
    };
  }, [registry, location.id, scheduleDebouncedSave, doSave]);
  if (!form) return null;
  return _jsx(WizardTable, __assign({
    headers: _jsxs(_Fragment, {
      children: [_jsx(TableCell, {
        children: tReview('locationColumn')
      }), _jsx(TableCell, {
        children: t('locationType')
      }), _jsx(TableCell, {
        children: t('region')
      }), _jsx(TableCell, {
        children: t('country')
      }), _jsx(TableCell, {
        children: t('stateProvince')
      }), _jsx(TableCell, {
        children: t('city')
      }), _jsx(TableCell, __assign({
        align: "center"
      }, {
        children: t('numberOfSeats')
      }))]
    })
  }, {
    children: _jsx(TableBody, {
      children: _jsxs(TableRow, {
        children: [_jsx(TableCell, __assign({
          sx: {
            minWidth: 160,
            bgcolor: 'background.default'
          }
        }, {
          children: _jsx(TextField, {
            size: "small",
            fullWidth: true,
            disabled: isReadOnly,
            value: form.locationName,
            onChange: function (e) {
              return handleFormChange(function (f) {
                return __assign(__assign({}, f), {
                  locationName: e.target.value,
                  isDirty: true
                });
              });
            },
            error: !isReadOnly && !form.locationName.trim()
          })
        })), _jsx(TableCell, __assign({
          sx: {
            minWidth: 140
          }
        }, {
          children: _jsx(StableAutocomplete, {
            size: "small",
            value: form.locationType,
            options: [{
              id: 'in_house',
              name: t('locationTypeInHouse')
            }, {
              id: 'outsourced',
              name: t('locationTypeOutsourced')
            }],
            disabled: isReadOnly,
            onChange: function (v) {
              return handleFormChange(function (f) {
                return __assign(__assign({}, f), {
                  locationType: v,
                  isDirty: true
                });
              });
            }
          })
        })), _jsx(TableCell, {
          children: (_c = location.region) !== null && _c !== void 0 ? _c : '-'
        }), _jsx(TableCell, {
          children: location.countryName
        }), _jsx(TableCell, {
          children: (_d = location.stateProvince) !== null && _d !== void 0 ? _d : '-'
        }), _jsx(TableCell, {
          children: (_e = location.city) !== null && _e !== void 0 ? _e : '-'
        }), _jsx(TableCell, __assign({
          align: "center"
        }, {
          children: location.totalSeats == null ? t('unlimited') : formatNumberByLocale(location.totalSeats)
        }))]
      })
    })
  }));
};